import Image from 'next/image'
import styled, { css } from 'styled-components'

import { DozerLoading } from './DozerLoading'

import logo from 'public/buildpass.svg'

const LoadingContainer = styled.div<{
  $cover?: 'page' | 'content'
  $textAlign?: 'center' | 'right'
}>`
  text-align: ${({ $textAlign }) => $textAlign && `${$textAlign}!important`};

  ${(props) =>
    props.$cover === 'content' &&
    css`
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    `}

  ${(props) =>
    props.$cover === 'page' &&
    css`
      position: fixed;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    `}
`

type Props = {
  cover?: 'content' | 'page'
  align?: 'center' | 'right'
}

const Loading: React.FC<Props> = ({ cover, align = 'center' }) => {
  return (
    <LoadingContainer $cover={cover} $textAlign={align}>
      <DozerLoading text={'Loading'} loading size={32} relative noBackground />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginTop: '-24px',
        }}
      >
        <Image src={logo.src} alt="BuildPass" width={80} height={20} />
      </div>
    </LoadingContainer>
  )
}

export default Loading
